<template>
    <div class="content">
        <header-components activeClass="content"></header-components>
        <header-components-mobile></header-components-mobile>
        <section class="section section-two-side push-top">
            <div class="container">
                <div class="block">
                    <h2>Persyaratan Layanan (Terms of Service) &ndash; Safira Scola</h2>
                    <h4>Terakhir Diperbarui: 7 September 2026</h4>
                    <h3>1. Penerimaan Ketentuan</h3>
                    <p>Dengan mengakses atau menggunakan aplikasi Safira Scola, Anda menyetujui untuk terikat oleh Persyaratan Layanan ini. Jika Anda tidak menyetujui bagian mana pun dari ketentuan ini, Anda tidak diperkenankan menggunakan layanan kami.</p>
                    <h3>2. Penggunaan Layanan</h3>
                    <ul>
                        <li>Anda setuju untuk menggunakan Safira Scola hanya untuk tujuan yang sah dan sesuai dengan hukum yang berlaku.</li>
                        <li>Anda bertanggung jawab penuh atas aktivitas yang terjadi di bawah akun Anda saat terhubung melalui integrasi Google OAuth.</li>
                    </ul>
                    <h3>3. Hak Kekayaan Intelektual</h3>
                    <p>Seluruh hak milik, merek dagang, dan kode sumber aplikasi Safira Scola adalah milik pengembang. Pengguna diberikan lisensi terbatas, tidak eksklusif, dan tidak dapat dipindahtangankan untuk menggunakan aplikasi sesuai dengan peruntukannya.</p>
                    <h3>4. Batasan Tanggung Jawab</h3>
                    <p>Safira Scola disediakan "sebagaimana adanya" (as is) tanpa jaminan dalam bentuk apa pun. Kami tidak bertanggung jawab atas kerugian langsung maupun tidak langsung yang timbul akibat penggunaan atau ketidakmampuan dalam menggunakan layanan ini.</p>
                    <h3>5. Perubahan Ketentuan</h3>
                    <p>Kami berhak untuk memperbarui atau mengubah Persyaratan Layanan ini sewaktu-waktu. Perubahan akan berlaku segera setelah dipublikasikan di halaman ini.</p>
                    <h3>6. Kontak</h3>
                    <p>Jika Anda memiliki pertanyaan mengenai Persyaratan Layanan ini, silakan hubungi kami di: <a href="mailto:erickbudi.kurniawan@gmail.com">erickbudi.kurniawan@gmail.com</a>.</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import HeaderMobile from '@/components/HeaderMobile.vue'
    import lozad from 'lozad'
    export default {
        name: 'terms-of-service',
        components: {
            'header-components': Header,
            'header-components-mobile': HeaderMobile,
        },
        metaInfo: {
            title: 'Terms of Service',
            titleTemplate: '%s - Scola LMS | Tingkatkan Pembelajaran Di Sekolah Anda'
        },
        mounted() {
            const observer = lozad();
            observer.observe();
        }
    }
    </script>
